/* ============================================================
   BANNER CLICABLE ENTERO (15 ago 2026)

   Cubre .hero-nazalea con un enlace transparente que va al mismo sitio que
   el boton. El boton lo esconde assets/pn-hero.css, pero SIGUE EN EL HTML
   a proposito: es de donde se lee el destino.

   ⚠️ Si algun dia vacia "Texto del boton" en el personalizador, el boton
      deja de pintarse, aqui no hay href que leer y el banner deja de ser
      clicable. No es un fallo: es que se ha quitado la fuente del enlace.
   ============================================================ */
(function () {
  'use strict';

  function poner() {
    var heroes = document.querySelectorAll('.hero-nazalea');
    for (var i = 0; i < heroes.length; i++) {
      var hero = heroes[i];
      if (hero.querySelector('.pn-hero-enlace')) { continue; }
      var btn = hero.querySelector('.hero-nazalea__boton');
      var href = btn ? btn.getAttribute('href') : null;
      if (!href) { continue; }
      var a = document.createElement('a');
      a.className = 'pn-hero-enlace';
      a.setAttribute('href', href);
      a.setAttribute('aria-label', (btn.textContent || 'Ver la coleccion').trim());
      if (getComputedStyle(hero).position === 'static') {
        hero.style.setProperty('position', 'relative');
      }
      hero.appendChild(a);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', poner);
  } else {
    poner();
  }
  document.addEventListener('shopify:section:load', poner);
})();
